module.exports = {"410325100":"城关镇","410325101":"田湖镇","410325102":"旧县镇","410325103":"车村镇","410325104":"闫庄镇","410325105":"德亭镇","410325106":"大章镇","410325107":"白河镇","410325108":"纸房镇","410325109":"饭坡镇","410325110":"九皋镇","410325111":"陆浑镇","410325201":"大坪乡","410325203":"何村乡","410325209":"黄庄乡","410325210":"木植街乡","410325400":"陶村林场","410325401":"五马寺林场","410325402":"王莽寨林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410325.json
// module id = 1668
// module chunks = 0